<div class="pointsummarychart" [appIsLoading]="loadingService.isLoading(this)">
    <div *ngIf="lineChartData && lineChartData.datasets.length>0">
        <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'line'" [legend]="lineChartLegend"></canvas>
    </div>
</div>